import { useSearchParams } from 'react-router-dom';
import { Building2, Users, Map } from 'lucide-react';
import { PageShell } from '@/components/primitives/PageShell';
import { PageHeader } from '@/components/primitives/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import MembersParcelMap from './MembersParcelMap';
// Legacy lists — kept inline until their own rewrites (see c11 plan).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
import EstateListRaw from './EstateList';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
import FPAMemberListRaw from './FPAMemberList';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EstateList = EstateListRaw as any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FPAMemberList = FPAMemberListRaw as any;

type MembersTab = 'fpa' | 'estates' | 'map';

function parseTab(value: string | null): MembersTab {
  if (value === 'estates' || value === 'map') return value;
  return 'fpa';
}

export default function Members() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = parseTab(searchParams.get('tab'));

  const setTab = (next: string) => {
    const sp = new URLSearchParams(searchParams);
    sp.set('tab', next);
    setSearchParams(sp, { replace: true });
  };

  return (
    <PageShell>
      <PageHeader title="Members" subtitle="FPA members and estates" />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="fpa">
            <Users className="mr-2 h-4 w-4" />
            FPA members
          </TabsTrigger>
          <TabsTrigger value="estates">
            <Building2 className="mr-2 h-4 w-4" />
            Estates
          </TabsTrigger>
          <TabsTrigger value="map">
            <Map className="mr-2 h-4 w-4" />
            Map
          </TabsTrigger>
        </TabsList>
        <TabsContent value="fpa" className="mt-0">
          <FPAMemberList embedded />
        </TabsContent>
        <TabsContent value="estates" className="mt-0">
          <EstateList embedded />
        </TabsContent>
        <TabsContent value="map" className="mt-0">
          <MembersParcelMap />
        </TabsContent>
      </Tabs>
    </PageShell>
  );
}
